import cn from 'classnames';
import React, { FC, PropsWithChildren } from 'react';
import { PADDINGABLE_FOR_MOBILE_STATUS_BAR_CLASS } from 'students/constants';
import { SPage, SPageContainer } from 'students/views/shared/styled';
import styled, { StyledComponent } from 'styled-components';

export const PLAY_PAGE_DEFAULT_COLOR = '#4f398e';

export interface IPlayPage {
  className?: string;
  backgroundComponent?: StyledComponent<'div', any, any, never>;
  backgroundImageURL?: string | null;
  overlayColor?: string | null;
}

const PlayPage: FC<PropsWithChildren<IPlayPage>> = ({
  children,
  className,
  backgroundComponent,
  backgroundImageURL,
  overlayColor
}) => {
  const BackgroundComponent = backgroundImageURL
    ? SApiBackground
    : backgroundComponent || defaultDiv;

  return (
    <SPage className={cn(className)}>
      <BackgroundComponent
        className={cn(
          'ln-flex ln-flex-col ln-grow',
          PADDINGABLE_FOR_MOBILE_STATUS_BAR_CLASS
        )}
        style={
          backgroundImageURL
            ? ({
                '--api-bg-image': `url(${backgroundImageURL})`,
                '--overlay-color': overlayColor
                  ? `linear-gradient(${overlayColor}33, ${overlayColor}33), rgba(0, 0, 0, 0.3)`
                  : 'rgba(0, 0, 0, 0.35)'
              } as React.CSSProperties)
            : undefined
        }
      >
        <SPageContainer>{children}</SPageContainer>
      </BackgroundComponent>
    </SPage>
  );
};

const defaultDiv = styled.div`
  background-color: ${PLAY_PAGE_DEFAULT_COLOR};
`;

const SApiBackground = styled.div`
  background-image: var(--api-bg-image);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--overlay-color, rgba(0, 0, 0, 0.45));
    backdrop-filter: blur(6px);
    z-index: 0;
  }

  & > * {
    position: relative;
    z-index: 1;
  }
`;

export default PlayPage;
